module.exports = __webpack_public_path__ + "static/jls-homepage-c5d44695f14b2376eca4f36a1fc6e243.png";